import { cn } from '@bells/core/lib/utils';

function Skeleton({
  className,
  animated = true,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & { animated?: boolean }) {
  return (
    <div
      className={cn('rounded-md bg-primary/10', className, {
        'animate-pulse': animated,
      })}
      {...props}
    />
  );
}

export { Skeleton };
